import React from 'react';
import PropTypes from 'prop-types';

import { formatProcessInstanceId } from '../../utils/formatting_utils';
import ActivityStatuses from '../constants/activity_statuses';

export default class ProcessDetails extends React.Component {
	static propTypes = {
		title: PropTypes.string,
		userName: PropTypes.string,
		status: PropTypes.string,
		processInstanceId: PropTypes.number,
		isMobile: PropTypes.bool,
		isECMLicenseFull: PropTypes.bool
	};

	static defaultProps = {
		processIds: {},
		title: '-',
		userName: '-',
		status: '-',
		processInstanceId: 0,
		isMobile: false,
	};

	getFormattedProcessCode() {
		const processInstanceId = this.props.processInstanceId;
		return formatProcessInstanceId(processInstanceId);
	}

	getTranslatedProcessStatusName() {
		const status = this.props.status;
		return Object.keys(ActivityStatuses).reduce((previousValue, statusKey) => {
			if(ActivityStatuses[statusKey] == status)
				return Realize.i18n.t(`activity.status.${statusKey}`);

			return previousValue;
		}, status);
	}

	renderProcessTitle() {
		return (
			<span title={this.props.title} className="strong">
			{this.props.title}
			</span>
		);
	}

	renderProcessUser() {
		return (
			<span>
			<span>{` ${Realize.i18n.t('by')} `}</span>
			<span title={this.props.userName} className="strong">
			{this.props.userName}
			</span>
			</span>
		);
	}

	renderProcessStatus() {
		return this.renderProcessItem(
			Realize.i18n.t('processInstance.status'),
			this.getTranslatedProcessStatusName()
		);
	}

	renderProcessCode() {
		return this.renderProcessItem(
			Realize.i18n.t('processInstance.code'),
			this.getFormattedProcessCode()
		);
	}

	renderProcessItem(itemLabel, itemValue) {
		return (
			<div className="process-details__item col s6" tabIndex="0" aria-label={`${itemLabel} ${itemValue}`}>
				<div className="item__title">{itemLabel}</div>
				<span className="item__value strong">{itemValue}</span>
			</div>
		);
	}

	renderWorkspaceDesktop(){
		return (
			<div className="process-details sub-header grey lighten-2 row">
			<div className="process-details__title col s12 m8 l9" tabIndex="0" aria-label={`${this.props.title} ${Realize.i18n.t('by')} ${this.props.userName}`}>
			{this.renderProcessTitle()}
			{this.renderProcessUser()}
			</div>

			<div className="process-details__items col s12 m4 l3 row">
			{this.renderProcessStatus()}
			{this.renderProcessCode()}						
			</div>
			</div>
		);
	}

	renderWorkspaceMobile(){
		return (
			<div className="process-details sub-header mobile">
			<div className="process-details__title">
			<span className="strong">{`#${this.getFormattedProcessCode()}`}</span>
			<span className="vertical-line"></span>
			<span className="strong">{this.props.title}</span>
			</div>
			</div>
		);
	}

	render() {
		return (this.props.isMobile)
		? this.renderWorkspaceMobile()
		: this.renderWorkspaceDesktop();
	}
}
